// extracted by mini-css-extract-plugin
export default {"filtersWrapper":"FiltersWrapper_filtersWrapper__HeG-I","filters":"FiltersWrapper_filters__Nom5M"};